import { render, staticRenderFns } from "./SearchComplaints.vue?vue&type=template&id=2196969c"
import script from "./SearchComplaints.vue?vue&type=script&lang=js"
export * from "./SearchComplaints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports